import * as React from 'react'
import { ReactElement } from 'react'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import { LegalPersonMutationDto } from '../../../config/partyMutationConfig'
import FieldRow from './FieldRow'
import FormikInputField from '../../../../components/Formik/FormikInputField'
import FormikCheckboxField from '../../../../components/Formik/FormikCheckboxField'
import { formatMultipleEmailAddresses } from '../../../../helpers/regexHelper'

/**
 * Financial/invoicing details of a legal person — only when the Invoices module is active.
 * The finance e-mail accepts multiple `;`-separated addresses, like the contact e-mail.
 */
export default function FinanceSection(): ReactElement {
    const { t: translate } = useTranslation()
    const { setFieldValue } = useFormikContext<LegalPersonMutationDto>()

    return (
        <>
            <FieldRow>
                <FormikInputField<LegalPersonMutationDto>
                    labelKey="party.edit.finance.financeterminvoice"
                    fieldName="financeTermInvoice"
                    componentProps={{ contentAfter: translate('party.edit.finance.financetermpayment.days') }}
                />
                <FormikInputField<LegalPersonMutationDto>
                    labelKey="party.edit.finance.financetermpayment"
                    fieldName="financeTermPayment"
                    componentProps={{ contentAfter: translate('party.edit.finance.financetermpayment.days') }}
                />
            </FieldRow>
            <FormikInputField<LegalPersonMutationDto>
                labelKey="party.edit.finance.financeemail"
                fieldName="financeEmail"
                componentProps={{
                    onBlur: (e: React.FocusEvent<HTMLInputElement>) =>
                        setFieldValue('financeEmail', formatMultipleEmailAddresses(e.target.value)?.join(';')),
                }}
            />
            <FormikInputField<LegalPersonMutationDto> labelKey="party.edit.finance.vatnumber" fieldName="vatNumber" />
            <FieldRow>
                <FormikCheckboxField<LegalPersonMutationDto> labelKey="party.edit.finance.filereferencerequired" fieldName="fileReferenceRequired" />
                <FormikInputField<LegalPersonMutationDto> labelKey="party.edit.finance.reference" fieldName="reference" />
            </FieldRow>
        </>
    )
}
